import PropTypes from 'prop-types';

export default function DirectAvatar({ source, altcap }) {
  return <img src={source} alt={altcap} />;
}

DirectAvatar.propTypes = {
  source: PropTypes.string.isRequired,
  altcap: PropTypes.string,
};
